/**
 * 外部認証プロバイダ（Firebase Auth など）からのエラーを
 * クライアントに伝搬させるためのドメインエラー。
 *
 * `providerCode` には Firebase の `auth/weak-password` のような
 * コード値が入る。GraphQL エラー extensions に乗せてクライアント側で
 * 具体的なメッセージ分岐に使う想定。
 */
export class AuthProviderError extends Error {
  readonly name: string

  readonly __proto__: AuthProviderError

  readonly providerCode: string

  constructor(providerCode: string, message?: string) {
    const prototype = new.target.prototype
    super(message ?? providerCode)
    this.__proto__ = prototype
    this.name = "AUTH_PROVIDER_ERROR"
    this.providerCode = providerCode
  }
}
